module.exports = __webpack_public_path__ + "img/image_address-d35a2abc.png";